/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import React from 'react';

// 色の定義
const COLOR_MAP = {
  success: {
    background: '#e8f4e8',
    text: '#4caf50',
  },
  disabled: {
    background: '#e7e7e7ff',
    text: '#666666',
  },
  warning: {
    background: '#fee8c1ff',
    text: '#f18b05',
  },
  alert: {
    background: '#ffd4d4',
    text: '#e63a1c',
  },
} as const;

// 型定義
export type StatusColorType = keyof typeof COLOR_MAP;
export type StatusSizeType = 'small' | 'medium' | 'large';

type StatusLabelProps = {
  label: string;
  color: StatusColorType;
  size?: StatusSizeType;
  className?: string;
};

// サイズの定義
const SIZE_MAP = {
  small: {
    fontSize: 10,
    padding: '0 8px',
    height: 16,
    borderRadius: 12,
  },
  medium: {
    fontSize: 12,
    padding: '2px 12px',
    height: 20,
    borderRadius: 14,
  },
  large: {
    fontSize: 14,
    padding: '4px 16px',
    height: 24,
    borderRadius: 16,
  },
} as const;

export const StatusLabel: React.FC<StatusLabelProps> = ({
  label,
  color,
  size = 'small',
  className,
}) => {
  const colorConfig = COLOR_MAP[color];
  const sizeConfig = SIZE_MAP[size];

  return (
    <span
      className={className}
      css={css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: ${colorConfig.background};
        color: ${colorConfig.text};
        font-size: ${sizeConfig.fontSize}px;
        font-weight: 600;
        padding: ${sizeConfig.padding};
        height: ${sizeConfig.height}px;
        border-radius: ${sizeConfig.borderRadius}px;
        white-space: nowrap;
        line-height: 1.2;
      `}
    >
      {label}
    </span>
  );
};
